import { Injectable } from '@angular/core';
import { ArrowNavConf, AvailableColumnValue } from './header-search.component';


@Injectable({
  providedIn: 'root'
})
export class SearchArrowNavigationService {

  public entitiesCount: Array<number> = [0, 0, 0];

  constructor() {
  }

  /**
   * Sets the row position in the search dropdown
   * @param dir: next position
   * @param currConf: actual arrow navigation column and row positions
   */
  public moveUpAndDown(dir: string, currConf: ArrowNavConf): ArrowNavConf {
    const lastItem = this.entitiesCount[currConf.selectedColumn] - 1;
    const up = dir === 'up';
    if (up ? currConf.selectedRow <= 0 : currConf.selectedRow >= lastItem) {
      return this.sideMove(dir, currConf);
    } else {
      return {
        selectedColumn: currConf.selectedColumn,
        selectedRow: up ? --currConf.selectedRow : ++currConf.selectedRow
      };
    }
  }

  /**
   * Sets column position in the search dropdown
   * @param dir: next position
   * @param currConf: actual arrow navigation column and row positions
   */
  public sideMove(dir: string, currConf: ArrowNavConf): ArrowNavConf {
    const selectedColumn = this.moveToColIfExists(dir, currConf);
    const selectedRow = dir === 'up' ? this.entitiesCount[selectedColumn] - 1 : 0;
    return {
      selectedColumn,
      selectedRow
    };
  }

  /**
   * Finds next or prev available column to be focused on, or keep the same position
   * @param dir
   * @param currConf
   */
  private moveToColIfExists(dir: string, currConf: ArrowNavConf): AvailableColumnValue {
    /**
     * If there are no column to move on, stay in the same horizontal position
     */
    if (this.singleColResults()) {
      return currConf.selectedColumn;
    }
    return dir === 'up' ? this.findPrevCol(currConf.selectedColumn) : this.findNextCol(currConf.selectedColumn);
  }

  /**
   * Finds the next column or skips to the other one
   * @param currentCol
   */
  private findNextCol(currentCol: AvailableColumnValue): AvailableColumnValue {
    // TODO: use recursive check instead of hard coded column position checks
    if (currentCol === 0 && this.entitiesCount[1] > 0) {
      return 1;
    } else if (currentCol === 0 && this.entitiesCount[1] <= 0) {
      return 2;
    }
    if (currentCol === 1 && this.entitiesCount[2] > 0) {
      return 2;
    } else if (currentCol === 1 && this.entitiesCount[2] <= 0) {
      return 0;
    }
    if (currentCol === 2 && this.entitiesCount[0] > 0) {
      return 0;
    } else if (currentCol === 2 && this.entitiesCount[0] <= 0) {
      return 1;
    }
    // It might never reach this line because of the `singleColResults` validation but keep it as a fallback
    return currentCol;
  }

  /**
   * Finds the previous column or skips to the other one
   * @param currentCol
   */
  private findPrevCol(currentCol: AvailableColumnValue): AvailableColumnValue {
    // TODO: use recursive check instead of hard coded column position checks
    if (currentCol === 2 && this.entitiesCount[1] > 0) {
      return 1;
    } else if (currentCol === 2 && this.entitiesCount[1] <= 0) {
      return 0;
    }
    if (currentCol === 1 && this.entitiesCount[0] > 0) {
      return 0;
    } else if (currentCol === 1 && this.entitiesCount[0] <= 0) {
      return 2;
    }
    if (currentCol === 0 && this.entitiesCount[2] > 0) {
      return 2;
    } else if (currentCol === 0 && this.entitiesCount[2] <= 0) {
      return 1;
    }
    // It might never reach this line because of the `singleColResults` validation but keep it as a fallback
    return currentCol;
  }

  /**
   * Find if there are at least two columns with results
   */
  private singleColResults(): boolean {
    return this.entitiesCount.filter(item => item === 0).length > 1;
  }
}
